import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOsdDetails } from "../models/osd";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type string[]
 */

export const exceptionDetails = async (osdId: string | undefined, headers: Record<string, string> = {}): Promise<IOsdDetails> => {
  try {
    const url = `${getUrl(ApiType.EXCEPTION_DETAILS)}/${osdId}`;
    let defaultHeaders = {
      "Content-Type": "application/json",
      "OSD-Section-Name": "osdDescription",
      "OSD-Action-Type": "get",
      "OSD-Exception-Number": osdId,
    };
    const response = await axios.get(url, { headers: { ...defaultHeaders, ...headers } });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.exceptionDetails, { badRequestOrder: "errorsFirst" });
  }
};
